<div class="row">
  <div class="col-12">
    <nb-card class="mb-4">
      <nb-card-header>
        <div class="d-flex justify-content-between align-items-center">
          <div>
            <button nbButton outline status="primary" class="me-3" (click)="navigateBack()">
              <i class="fas fa-arrow-left"></i> Back
            </button>
            <h2 class="d-inline">NFC Reader Status: {{ storeName }}</h2>
          </div>
        </div>
      </nb-card-header>
      <nb-card-body>
        <!-- Store Info -->
        <div class="row mb-4 text-center">
          <div class="col-md-3">
            <nb-card [status]="storeInfo.isNfcReaderEnabled ? 'success' : 'warning'">
              <nb-card-body>
                <h6>NFC Reader Enabled</h6>
                <h3>{{ storeInfo.isNfcReaderEnabled ? 'Yes' : 'No' }}</h3>
              </nb-card-body>
            </nb-card>
          </div>
          <div class="col-md-3">
            <nb-card [status]="uptimePercentage > 90 ? 'success' : (uptimePercentage > 75 ? 'warning' : 'danger')">
              <nb-card-body>
                <h6>Uptime Percentage</h6>
                <h3>{{ uptimePercentage }}%</h3>
              </nb-card-body>
            </nb-card>
          </div>
          <div class="col-md-3">
            <nb-card status="success">
              <nb-card-body>
                <h6>Last Online</h6>
                <h6>{{ getLastStatusTimestamp('online') }}</h6>
              </nb-card-body>
            </nb-card>
          </div>
          <div class="col-md-3">
            <nb-card status="danger">
              <nb-card-body>
                <h6>Last Offline</h6>
                <h6>{{ getLastStatusTimestamp('offline') }}</h6>
              </nb-card-body>
            </nb-card>
          </div>
        </div>

        <!-- Summary Numbers -->
        <div class="row mb-4 text-center">
          <div class="col-md-4">
            <nb-card status="success">
              <nb-card-body>
                <h6>Online Count</h6>
                <h3>{{ getOnlineCount() }}</h3>
              </nb-card-body>
            </nb-card>
          </div>
          <div class="col-md-4">
            <nb-card status="danger">
              <nb-card-body>
                <h6>Offline Count</h6>
                <h3>{{ getOfflineCount() }}</h3>
              </nb-card-body>
            </nb-card>
          </div>
          <div class="col-md-4">
            <nb-card status="info">
              <nb-card-body>
                <h6>Total Readings</h6>
                <h3>{{ getTotalReadingsCount() }}</h3>
              </nb-card-body>
            </nb-card>
          </div>
        </div>

        <!-- Date Range Selector -->
        <div class="row mb-4">
          <div class="col-12">
            <nb-card>
              <nb-card-body>
                <div class="row mb-2">
                  <div class="col">
                    <h6>Date Range Filter</h6>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-8">
                    <input nbInput placeholder="Date Range" [nbDatepicker]="rangepicker" [(ngModel)]="date">
                    <nb-rangepicker #rangepicker (rangeChange)="updateRangeDate($event)"></nb-rangepicker>
                  </div>
                  <div class="col-md-2">
                    <button nbButton status="primary" (click)="clearDate()">Clear</button>
                  </div>
                  <div class="col-md-2">
                    <div class="form-group">
                      <select nbSelect fullWidth [(ngModel)]="selectedInterval" (change)="onIntervalChange($event)">
                        <option value="15min">15 Minutes</option>
                        <option value="hour">Hourly</option>
                        <option value="day">Daily</option>
                        <option value="month">Monthly</option>
                      </select>
                    </div>
                  </div>
                </div>
              </nb-card-body>
            </nb-card>
          </div>
        </div>

        <!-- Graph -->
        <div class="row">
          <div class="col-12">
            <div class="chart-container" style="position: relative; height:400px; width:100%">
              <canvas baseChart
                [type]="lineChartType"
                [data]="lineChartData"
                [options]="lineChartOptions">
              </canvas>
            </div>
          </div>
        </div>
      </nb-card-body>
    </nb-card>
  </div>
</div>

<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="large" color="white" type="ball-circus" [fullScreen]="true">
  <p style="color: white">Loading...</p>
</ngx-spinner> 